import { useMutation } from '@tanstack/react-query'
import { UserController } from 'src/controllers/user.controller'

const userController = new UserController()

interface ValidateConfirmationCodeParams {
  username: string
  codigo: string
  tipo: 'TELEFONE' | 'EMAIL'
}

export function useValidateConfirmationCode() {
  return useMutation<void, Error, ValidateConfirmationCodeParams>({
    mutationKey: ['validateConfirmationCode'],
    mutationFn: ({ username, codigo, tipo }) => userController.validateConfirmationCode(username, codigo, tipo)
  })
}
